export default __webpack_public_path__ + "static/media/battery.c3ba1e18.png";